<template>
  <div>
    <div class="search-box navbar-item">
      <p class="control has-icons-right">
        <input
          v-model="search_input"
          class="input expanding-input"
          type="search"
          :placeholder="$t('common.search')+'...'"
          @focus="showDropdown()"
          @blur="hideDropdown()"
        >
        <span class="icon is-small is-right" style="width: 46px;">
          <i class="fa fa-search search-icon" aria-hidden="true"></i>
        </span>
      </p>
      <div class="dropdown">
        <div class="drop-down">
          <ul :style="show_dropdown ? 'display: block !important': 'display:none !important'">
            <li v-if="is_loading" style="display: table; margin: 0 auto 0 auto;"><div class="search-box-loader"></div></li>
            <template v-if="products.length">
              <li v-for="(product, index) in products" :key="product.id">
                <a :href="product.url">
                  <div class="columns is-mobile">
                    <div data-v-50623d50="" class="column is-1 product-row-image" style="min-width: 130px;">
                      <figure data-v-50623d50="" class="image is-16by9">
                        <img data-v-50623d50="" :src="product.images['16by9']" title="" class="search-box-image-borders" style="max-height: 4rem;">
                      </figure>
                    </div>
                    <div class="column is-align-self-center is-flex-grow-5">
                      <div class="search-box-product-title">
                        {{product.name}}
                      </div>
                    </div>
                    <div class="column is-align-self-center">
                      <div v-if="parseInt(product.price)" class="search-box-price">
                        {{product.price}} {{product.currency}}
                      </div>
                    </div>
                  </div>
                </a>
                <div v-if="index !== products.length - 1" class="search-box-product-separator mt-1 mb-1" />
              </li>
            </template>
            <template v-else-if="!is_loading">
              <li>{{$t('common.no-results-found')}}</li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { debounce } from 'lodash';
import ProductsApi from '../../api/products';

export default {
  name: 'ProductSearchInput',
  data() {
    return {
      api: new ProductsApi(),
      search_input: '',
      show_dropdown: false,
      is_loading: true,
      products: []
    };
  },
  watch: {
    search_input(value) {
      this.show_dropdown = value ? true : false;
      this.search(value);
    }
  },
  methods: {
    search: debounce(function search(query) {
      this.products = [];
      if (query) {
        this.is_loading = true;
        this.api.fuzzySearch(query).then(response => {
          this.is_loading = false;
          this.products = response.data;
          VueEventHub.$emit('product-search', query);
        }).catch(() => {
          this.is_loading = false;
        });
      }
    }, 300),
    showDropdown() {
      if (this.search_input) {
        this.show_dropdown = true;
      }
    },
    hideDropdown() {
      //delay the hiding of the box until click on link fires
      const $vue = this;
      setTimeout(function () {
        $vue.show_dropdown = false;
      }, 200);
    }
  }
};
</script>
